"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _underscore = _interopRequireDefault(require("underscore"));

var _react2 = _interopRequireDefault(require("@tippyjs/react"));

var _Link = _interopRequireDefault(require("../general/Link"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @enum {string}
 * @alias HelpHint.Placements
 */
var Placements = {
  /** top */
  TOP: "top",

  /** top-start */
  TOP_START: "top-start",

  /** top-end */
  TOP_END: "top-end",

  /** bottom */
  BOTTOM: "bottom",

  /** bottom-start */
  BOTTOM_START: "bottom-start",

  /** bottom-end */
  BOTTOM_END: "bottom-end",

  /** left */
  LEFT: "left",

  /** left-start */
  LEFT_START: "left-start",

  /** left-end */
  LEFT_END: "left-end",

  /** right */
  RIGHT: "right",

  /** right-start */
  RIGHT_START: "right-start",

  /** right-end */
  RIGHT_END: "right-end"
};
/**
 * @enum {string}
 * @alias HelpHint.Types
 */

var Types = {
  DEFAULT: "",

  /** error */
  ERROR: "error",

  /** light */
  LIGHT: "light",

  /** success */
  SUCCESS: "success",

  /** warning */
  WARNING: "warning"
};
/**
 * @class HelpHint
 * @desc HelpHint can appear above, to the right, to the bottom or to the left of any DOM element.
 *     By default the hint appears to the upper right of the icon or target
 *     The following css classes may be added to effect the tooltip placement and state:
 *         'right': tooltip displays to the left of the icon instead of the right
 *         'bottom': tooltip displays under the help icon instead of above
 *         'show': keeps tooltip visible regardless of hover
 *     The following css classes maybe added to change the appearance of the tooltip:
 *         'error'/'warning': tooltip shows in red
 *         'success': tooltip shows in green
 *     Multiple rows of text are supported.
 *     HTML is supported.
 *
 * @param {string} [className]
 *     CSS classes to set on the top-level HTML container.
 * @param {string} [data-id="helpHint"]
 *     To define the base "data-id" value for top-level HTML container.
 * @param {number} [delayHide=400]
 *     Sets the number of milliseconds to wait before hiding the tooltip.
 * @param {number} [delayShow=0]
 *     Sets the number of milliseconds to wait before showing the tooltip.
 *
 * @param {any} hintText
 *     Provides the text that will appear in the hint.
 *
 * @param {string} link
 *     Provides a URL for a "More on this topic" link at the bottom of the tooltip.
 * @param {Object} linkProps
 *     Props object that is passed into the Link node when link is present.
 * @param {HelpHint.Placements} [placement]
 *     How to place the help hint.
 * @param {HelpHint.Types} [type]
 *     Sets special styling for the help hint.
 * @param {bool} [unstyleTrigger=false]
 *     When set, don't apply any styling to the helphint trigger.
 *
 *  @example
 *     <HelpHint className="short-tooltip right" hintText="My first HelpHint!">SomeTextWithHelp</HelpHint>
 */

var HelpHint = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(HelpHint, _React$Component);

  var _super = _createSuper(HelpHint);

  function HelpHint() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, HelpHint);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleClick", function (e) {
      // Kill click event to prevent event from triggering label from checking a checkbox/radio
      e.preventDefault();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getPlacement", function () {
      var _this$props = _this.props,
          classNames = _this$props.classNames,
          propsPlacement = _this$props.placement;
      var placement = "right"; // use newer placement prop if present

      if (propsPlacement) {
        placement = propsPlacement; // otherwise try parsing it from the className prop
        // since react tooltip only has 4 postions, precedence is given to top/bottom over left/right
      } else if (classNames) {
        placement = (0, _indexOf.default)(classNames).call(classNames, "left") > -1 ? "left" : placement;
        placement = (0, _indexOf.default)(classNames).call(classNames, "top") > -1 ? "top" : placement;
        placement = (0, _indexOf.default)(classNames).call(classNames, "bottom") > -1 ? "bottom" : placement;
      }

      return placement;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getTypeClass", function () {
      return _this.props.type ? "help-tooltip--".concat(_this.props.type) : null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "maybeRenderExtraContainer", function (children) {
      return _this.props.unstyleTrigger ? /*#__PURE__*/_react.default.createElement("div", {
        className: "help-tooltip help-tooltip--extra"
      }, children) : children;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "tooltipClassName", _this.props.link ? (0, _classnames2.default)("tooltip-text", "tooltip-text-link") : "tooltip-text");
    return _this;
  }

  (0, _createClass2.default)(HelpHint, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _context2;

      if (this.props.show || (0, _indexOf.default)(_context2 = this.props.className).call(_context2, "show") > -1) {
        this.show();
      }
    }
  }, {
    key: "getIconName",
    value: function getIconName() {
      var _this$props2 = this.props,
          iconName = _this$props2.iconName,
          lock = _this$props2.lock;

      if (iconName) {
        return "icon-".concat(iconName);
      } else {
        return lock ? "icon-lock" : "icon-help";
      }
    }
  }, {
    key: "maybeRenderLink",
    value: function maybeRenderLink() {
      var _this$props3 = this.props,
          link = _this$props3.link,
          linkProps = _this$props3.linkProps;
      return (link || linkProps) && /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends2.default)({
        title: "More on this topic",
        url: link,
        icon: "info",
        type: "block"
      }, linkProps));
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames,
          _this2 = this;

      var _this$props4 = this.props,
          dataId = _this$props4["data-id"],
          children = _this$props4.children,
          containerClassName = _this$props4.containerClassName,
          leftMargin = _this$props4.leftMargin,
          unstyleTrigger = _this$props4.unstyleTrigger;

      var iconName = this.getIconName(),
          uid = _underscore.default.uniqueId("rtt_"),
          display = children ? children : /*#__PURE__*/_react.default.createElement("span", {
        className: iconName,
        "data-id": dataId + "-icon"
      });

      var containerClassNames = (0, _classnames2.default)("help-tooltip", (_classnames = {}, (0, _defineProperty2.default)(_classnames, containerClassName, containerClassName !== undefined), (0, _defineProperty2.default)(_classnames, "help-tooltip--left-margin", leftMargin), _classnames));
      var tippyClassNames = (0, _classnames2.default)(this._getTypeClass(), {
        "help-tooltip": !unstyleTrigger
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: containerClassNames,
        "data-id": dataId
      }, /*#__PURE__*/_react.default.createElement(_react2.default, (0, _extends2.default)({
        placement: this.props.placement,
        className: tippyClassNames,
        interactive: true,
        content: /*#__PURE__*/_react.default.createElement("span", {
          id: uid,
          className: this.tooltipClassName
        }, this.props.hintText, this.maybeRenderLink()),
        appendTo: document.body,
        theme: this.props.type,
        delay: [this.props.delayShow, this.props.delayHide]
      }, this.props.tooltipProps), /*#__PURE__*/_react.default.createElement("div", {
        "data-id": dataId + "-target",
        className: (0, _classnames2.default)(this.props.className, "help-tooltip-target", {
          "inline": !children && !this.props.className // make the icon inline if no other class is specified

        }),
        onClick: this._handleClick,
        "data-tip": true,
        "data-for": uid,
        ref: function ref(target) {
          _this2.target = target;
        }
      }, display)));
    }
  }]);
  return HelpHint;
}(_react.default.Component);

(0, _defineProperty2.default)(HelpHint, "propTypes", {
  className: _propTypes.default.string,
  containerClassName: _propTypes.default.string,
  "data-id": _propTypes.default.string,
  delayHide: _propTypes.default.number,
  delayShow: _propTypes.default.number,
  hintText: _propTypes.default.any.isRequired,
  iconName: _propTypes.default.string,
  leftMargin: _propTypes.default.bool,
  link: _propTypes.default.string,
  linkProps: _propTypes.default.shape({}),
  placement: _propTypes.default.oneOf((0, _values.default)(Placements)),
  type: _propTypes.default.oneOf((0, _values.default)(Types)),
  tooltipProps: _propTypes.default.object,
  unstyleTrigger: _propTypes.default.bool
});
(0, _defineProperty2.default)(HelpHint, "defaultProps", {
  "data-id": "helpHint",
  delayHide: 400,
  delayShow: 0,
  className: "",
  leftMargin: false,
  unstyleTrigger: false,
  placement: "right"
});
module.exports = HelpHint;
module.exports.Placements = Placements;
module.exports.Types = Types;
module.exports.placements = Placements;
module.exports.types = Types;